import { reportTelemetryEventsInBatches } from '../report';

type FlushTelemetryEvents = () => Promise<void>;
export const flushTelemetryEvents: FlushTelemetryEvents = async () => {
  await reportTelemetryEventsInBatches();
};
